/**
 * Calculation utilities for Change Plan amendment
 *
 * Re-exports shared calculation functions from ../../shared/calculations.js
 * and provides Change Plan specific calculations
 */

// Re-export shared calculations
export {
  calculateGroupTotal,
  formatPremium,
  calculateAllGroupTotals
} from '../../shared/calculations';

/**
 * Calculate premium change between old and new member sets
 * @param {Array} oldMembers - Original members
 * @param {Array} newMembers - Members with new premiums
 * @returns {Object} - Object with oldTotal, newTotal, difference in cents
 */
export const calculatePremiumChange = (oldMembers, newMembers) => {
  const oldTotal = oldMembers.reduce((sum, m) => sum + (m.premium_amount_in_cents || 0), 0);
  const newTotal = newMembers.reduce((sum, m) => sum + (m.premium_amount_in_cents || 0), 0);

  return {
    oldTotal,
    newTotal,
    difference: newTotal - oldTotal,
    isIncrease: newTotal > oldTotal,
    isDecrease: newTotal < oldTotal
  };
};
